import pinkgem from './Images/pinkgem.jpg';
import moonearHollow from './Images/MoonEarrings.jpg';
import moonEar from './Images/Moonear.jpg';
import butterflyEar from './Images/bflyear.jpg';
import heartEar from './Images/heartear.jpg';
import purpgem from './Images/purpgem.jpg';




const productsData= [
    {Name: 'Pink Gem Earrings' , image:pinkgem, Price: 'INR 60', id:1 ,Ftype:'Earrings'},
    {Name: 'Moon Crossed Earrings' , image:moonEar ,Price: 'INR 70',id:2,Ftype:'Earrings'},
    {Name: 'Moon Earrings' , image:moonearHollow, Price: 'INR 50',id:3,Ftype:'Earrings'},
    {Name: 'Butterfly Earrings' , image:butterflyEar, Price: 'INR 70',id:4,Ftype:'Pendants'},
    {Name: 'Heart Earrings' , image:heartEar, Price: 'INR 80',id:5,Ftype:'Pendants'},
    {Name: 'Purple Gem Earrings' , image:purpgem, Price: 'INR 60',id:6,Ftype:'Earrings'},
   
]

export default productsData;